import React from 'react'
import NewQuestButtonUIMain from './NewQuestButtonUIMain'
import useGetQuest from 'refactor/hooks/api/useGetQuest'
import questModel from './questModel'
import useTeamLookup from 'components/teams/useTeamLookup'

export default function NewQuestButtonUIMainWrapper(props) {
    // If there's a questId in the filter, fetch the quest to ensure permissions are loaded
    const { quest } = useGetQuest(props.filter?.questId)
    const filterTeamId = props.filter?.team_ids?.[0]
    const { team } = useTeamLookup(filterTeamId, props.team)

    // Calculate permissions directly here where we have access to the reactive quest
    const perms = React.useMemo(() => {
        if (!props.filter) return null

        // If we have a questId and the quest is loaded, get perms from the quest
        if (props.filter.questId && quest) {
            return questModel.getPerms(quest)
        }

        // Otherwise use the standard permsFromFilter logic
        return questModel.permsFromFilter(props.filter, { team })
    }, [props.filter, quest, team])

    return <NewQuestButtonUIMain {...props} perms={perms} />
}
